import React, { Component } from "react";
import { Button, Row, Col, Alert, InputGroup } from "reactstrap";

import { RolodexForm } from "./RolodexForm";
import { LoadingModal } from "./LoadingModal";
import { FetchData } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

import AddIcon from "../images/add.png";

import { RolodexTableDefault } from "./RolodexTableDefault";

export class Rolodex extends Component {
  static displayName = Rolodex.name;

  constructor(props) {
    super(props);
    this.state = {
      isResizing: -1,

      rolodexList: [],
      loading: false,
      fetchingData: false,
      modal: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      model: {
        EventType: "insert",
        RolodexId: null,
        LastName: "",
        FirstName: "",
        Title: "",
        Speciality: "",
        Phone: "",
        Fax: "",
        Street: "",
        City: "",
        State: "",
        Zip: "",
        Note: "",
        Secretary: "",
        Label: "",
        Selected: false,

        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      searchModel: {
        Name: "",
        Title: "",
        Speciality: "",
        Phone: "",
        SortBy: "lastName",
        SortDirection: "asc",
      },
    };
    this.user = JSON.parse(GetCookie("user"));
    this.clickCount = 0;
    this.singleClickTimer = "";

    this.setModal = this.setModal.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.resetFields = this.resetFields.bind(this);

    this.renderRolodexTable = this.renderRolodexTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.populateRolodexData = this.populateRolodexData.bind(this);
  }

  componentDidMount() {
    //this.populateRolodexData();
  }

  setModal() {
    this.setState({ modal: !this.state.modal });
  }

  resetFields() {
    this.setState((prevState) => ({
      model: {
        EventType: "insert",
        RolodexId: null,
        LastName: "",
        FirstName: "",
        Title: "",
        Speciality: "",
        Phone: "",
        Fax: "",
        Street: "",
        City: "",
        State: "",
        Zip: "",
        Note: "",
        Secretary: "",
        Label: "",
        Selected: false,

        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
    }));

    this.setModal();
  }

  handleDoubleClick = (event) => {
    const rolData = event.data; // Accessing row data from the event object

    // Now, you can use this rowData to set your component's state or perform other actions
    this.setState((prevState) => ({
      model: {
        EventType: "update",
        RolodexId: rolData.rolodexId,
        LastName: rolData.lastName,
        FirstName: rolData.firstName,
        Title: rolData.fitle,
        Speciality: rolData.speciality,
        Phone: rolData.phone,
        Fax: rolData.fax,
        Street: rolData.street,
        City: rolData.city,
        State: rolData.state,
        Zip: rolData.zip,
        Note: rolData.note,
        Secretary: rolData.secretary,
        Label: rolData.label,
        Selected: rolData.selected,
        CreateDateTime: rolData.createDateTime,
        CreatebyUserId: rolData.createbyUserId,
        UpdateByUserId: rolData.updateByUserId,
        UpdateDateTime: rolData.updateDateTime,
        //IsDeletedFlg: false
      },
    }));
    this.setModal();
  };

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateRolodexData();
      }
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRolodexData();
    }
  }

  async populateRolodexData() {
    this.setState({ fetchingData: true });

    FetchData(
      "/getrolodex",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({ rolodexList: data, loading: false, fetchingData: false });
    });
  }

  renderRolodexTable() {
    return (
      <RolodexTableDefault
        rolodexList={this.state.rolodexList}
        handleDoubleClick={this.handleDoubleClick}
      />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRolodexTable()
    );
    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Rolodex</h5>
        <Row>
          <Col>
            <InputGroup size="sm">
              <Button color="btn" onClick={this.resetFields} size="sm">
                <img
                  src={AddIcon}
                  style={{ width: "16px", height: "16px" }}
                  alt="Add"
                />{" "}
              </Button>
              <input
                name="Name"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Name}
                onChange={this.handleSearchChange}
                placeholder="Contact Name (Lastname Firstname)"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Title"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Title}
                onChange={this.handleSearchChange}
                placeholder="Title"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Phone"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Phone}
                onChange={this.handleSearchChange}
                placeholder="Phone"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Speciality"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Speciality}
                onChange={this.handleSearchChange}
                placeholder="Speciality"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <LoadingModal fetchingData={this.state.fetchingData} />

        {this.state.modal && (
          <RolodexForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
          />
        )}

        <div>{contents}</div>
      </div>
    );
  }
}
